import React from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import CardBody from '../../common/CardBody';
import ProductImage from '../../common/ProductImage';
import EditButton from '../../common/EditButton';
import ViewButton from '../../common/ViewButton';
import DeleteButton from '../../common/DeleteButton';
import { Form } from 'react-bootstrap';

const FaqListBox = ({
      loading,
      items,
      totalItems,
      perPages,
      setLimit,
      currentPage,
      getData,
      fetchData,
      setSearch,
      setItems,
      setLoading
}) => {
      const token = JSON.parse(localStorage.getItem('token'));

      const handleStatus = async (faq) => {
            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/faqs/${faq.slug}/status`,
                        {},
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (faq) => {
            const response = await axios
                  .delete(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/faqs/${faq.slug}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setItems((items) =>
                                    items.filter((item) => item.id !== faq.id)
                              );
                              fetchData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <CardBody
                        totalItems={totalItems}
                        perPages={perPages}
                        setLimit={setLimit}
                        currentPage={currentPage}
                        getData={getData}
                        setSearch={setSearch}
                  >
                        <thead>
                              <tr>
                                    <th className="text-center" width="80px">
                                          #
                                    </th>
                                    <th>Question</th>
                                    <th width="130px">Date</th>
                                    <th width="80px">Status</th>
                                    <th width="120px">Action</th>
                              </tr>
                        </thead>

                        <tbody>
                              {!loading ? (
                                    items.length > 0 ? (
                                          items.map((item, index) => (
                                                <>
                                                      <tr key={index}>
                                                            <td className="text-center">
                                                                  {item.index}
                                                            </td>
                                                            <td>
                                                                  <ProductImage
                                                                        title={
                                                                              item.question
                                                                        }
                                                                        category={`Category: ${item.category}`}
                                                                  />
                                                            </td>
                                                            <td>{item.date}</td>
                                                            <td className="text-center">
                                                                  <Form.Check
                                                                        type="switch"
                                                                        id="custom-switch"
                                                                        defaultChecked={
                                                                              item.status ===
                                                                              1
                                                                                    ? true
                                                                                    : false
                                                                        }
                                                                        onClick={() =>
                                                                              handleStatus(
                                                                                    item
                                                                              )
                                                                        }
                                                                  />
                                                            </td>
                                                            <td className="text-center">
                                                                  <EditButton
                                                                        link={`/dashboard/faqs/${item.slug}/edit`}
                                                                  />
                                                                  <ViewButton
                                                                        link={`/dashboard/faqs/${item.slug}/show`}
                                                                  />
                                                                  <DeleteButton
                                                                        item={
                                                                              item
                                                                        }
                                                                        loading={
                                                                              loading
                                                                        }
                                                                        setLoading={
                                                                              setLoading
                                                                        }
                                                                        handleDelete={
                                                                              handleDelete
                                                                        }
                                                                  />
                                                            </td>
                                                      </tr>
                                                </>
                                          ))
                                    ) : (
                                          <>
                                                <tr>
                                                      <td
                                                            colSpan={5}
                                                            className="text-center"
                                                      >
                                                            No Faq Found
                                                      </td>
                                                </tr>
                                          </>
                                    )
                              ) : (
                                    <>
                                          <tr>
                                                <td
                                                      colSpan={5}
                                                      className="text-center"
                                                >
                                                      Loading...
                                                </td>
                                          </tr>
                                    </>
                              )}
                        </tbody>
                  </CardBody>
            </>
      );
};

export default FaqListBox;
